import {CellStyle} from './CellStyle';

export class FieldConfiguration {
fieldKind: string;
fileFieldIndex: number | null;
fileFieldName: string;
fileFieldSize: number | null;
outCondition: string;
specialField: string;
style: CellStyle;
tableFieldName: string;
tableName: string;
value: string;
}

